import { PureComponent, ReactNode } from 'react';
import Select, { StylesConfig } from 'react-select';
import { CSSObject } from '@emotion/serialize';
import { GMedicalRecordsWithTrack } from '../../pages/MedicalRecordsRightPanel';
import { uniqueBy } from '../../store/utils';

export type SuggestionItem = {
    label: string;
    value: string;
    tg?: string[];
};

const customStyles: StylesConfig<SuggestionItem, false> = {
    menuPortal: (base) => ({ ...base, zIndex: 9999, fontFamily: 'Lato' } as CSSObject),
};

type Props = {
    onChange: (item?: SuggestionItem | null) => void;
    value?: SuggestionItem | null;
    tagsGElements?: GMedicalRecordsWithTrack[];
};

export const OPTIONS = [
    {
        label: 'Prescription',
        value: 'ps',
    },
    {
        label: 'Lab Report',
        value: 'lr',
    },
    {
        label: 'Scans',
        value: 'sc',
    },
    {
        label: 'Others',
        value: 'ot',
    },
];

class MedicalRecordFileTypeSelector extends PureComponent<Props> {
    render(): ReactNode {
        const customRTtags = uniqueBy(
            'value',
            this.props.tagsGElements
                ?.filter((tag) => tag?.name?.startsWith('RT#'))
                ?.map((tag) => {
                    return {
                        value: tag.name,
                        label: tag.name.replace(/^RT#/, ''),
                    };
                }) || [],
        );

        const allRTTags = [...OPTIONS, ...(customRTtags || [])];

        const isCustomRecordType = this.props.value?.tg?.find((tag) => tag?.startsWith('RT#'));

        const value = isCustomRecordType
            ? {
                  ...(this.props.value || {}),
                  value: isCustomRecordType,
                  label: isCustomRecordType.replace(/^RT#/, ''),
              }
            : this.props.value;

        return (
            <Select
                styles={customStyles}
                isClearable={false}
                value={value}
                menuPortalTarget={document.body as HTMLElement}
                onChange={this.props.onChange}
                options={allRTTags}
                placeholder="Select file type"
            />
        );
    }
}

export default MedicalRecordFileTypeSelector;
